import color from 'color';

// export default {
//   // Color
//   brandPrimary: '#214392', // Color of the buttons and top most menu, blue
//   brandInfo: '#8703fc', // Violet color
//   brandSuccess: '#95c83f', // Color of secondary button and just below top menu, lime green
//   brandDanger: '#FF495F', // Light red
//   brandWarning: '#f99106', // Ochre
//   brandPink: '#eb3ff7',
//   brandYellow: '#f7ef4f',
//   brandLight: '#FFF',
//   brandMedium: '#808080',
//   facebookBlue: '#3b5998',
//   instagramPurple: '#C13584',
//   twitterBlue: '#1DA1F2',
//   googleRed: '#dd4b39',
//   brandGrey: '#091630',
//   brandDark: '#262f48',
//   brandGreen: '#c4eded',
//   brandHeaderBlue: '#1a6ba5',
//   brandLightOrange: '#feecd8',
//   brandTextOrange: '#e77a2c',
//   brandLightGreen: '#d7ebef',
//   brandDarkBlue: '#09164B',
//   // color mods
//   get brandPrimaryLight() {
//     return color(this.brandPrimary)
//       .lighten(0.8)
//       .hex();
//   },
//   get brandInfoLight() {
//     return color(this.brandInfo)
//       .lighten(0.5)
//       .hex();
//   },
//   get brandSuccessLight() {
//     return color(this.brandSuccess)
//       .lighten(0.5)
//       .hex();
//   },
//   get brandWarningLight() {
//     return color(this.brandWarning)
//       .lighten(0.5)
//       .hex();
//   },
//   get brandDangerLight() {
//     return color(this.brandDanger)
//       .lighten(0.1)
//       .hex();
//   },
//   get brandGreyLight() {
//     return color(this.brandDark)
//       .lighten(0.3)
//       .hex();
//   },
//   getBrandGreyLight(opacity = 0.1) {
//     const value = color(this.brandGrey)
//       .alpha(opacity);
//     return value;
//   },
// };

const Branding = {
  primaryBlue: '#0076BB',
  primaryOrange: '#F48120',
  secondaryPurple: '#704B9D',
  secondaryRed: '#EF493E',
  secondaryYellow: '#FFC52F',
  blueShade: '#E9F5FC',
  redShade: '#FFECEC',
  purpleShade: '#F2EAFC',
  grey: {
    900: '#080808',
    700: '#424141',
    600: '#656565',
    500: '#898989',
    200: '#D9D9D9',
    100: '#F5F5F5',
  },
  depricatedDefaultBackground: '#091630',
  depricatedPaperBackground: color('#091630')
    .lighten(0.3)
    .hex(),
};

export default Branding;
